var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:({
  gridColumn: _vm.pos[0], gridRow: _vm.pos[1]
}),attrs:{"src":_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }